module.exports = __webpack_public_path__ + "static/img/reference pics_AUS pool3.55fe9ab8.jpg";